/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick preset countdown`)
};

const es_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta regresiva predefinida rápida`)
};

const de_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneller Countdown mit Voreinstellung`)
};

const nl_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelle vooraf ingestelde aftelling`)
};

const fr_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à rebours prédéfini rapide`)
};

const it_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown preimpostato rapido`)
};

const pt_br2_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem regressiva predefinida rápida`)
};

const pt_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem decrescente predefinida rápida`)
};

const ja_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワンクリックのプリセットカウントダウン`)
};

const zh_timer_nav_preset_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速预设倒计时`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_nav_preset_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_nav_preset_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_nav_preset_desc", locale)
	if (locale === "en") return en_timer_nav_preset_desc(inputs)
	if (locale === "es") return es_timer_nav_preset_desc(inputs)
	if (locale === "de") return de_timer_nav_preset_desc(inputs)
	if (locale === "nl") return nl_timer_nav_preset_desc(inputs)
	if (locale === "fr") return fr_timer_nav_preset_desc(inputs)
	if (locale === "it") return it_timer_nav_preset_desc(inputs)
	if (locale === "pt-BR") return pt_br2_timer_nav_preset_desc(inputs)
	if (locale === "pt") return pt_timer_nav_preset_desc(inputs)
	if (locale === "ja") return ja_timer_nav_preset_desc(inputs)
	return zh_timer_nav_preset_desc(inputs)
};